import {
  Component,
  inject,
  Signal,
  signal,
  WritableSignal,
  input,
  InputSignal,
} from '@angular/core';
import {Store} from '@ngrx/store';
import {
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import {
  Subject,
  switchMap,
} from 'rxjs';
import {MatButton} from '@angular/material/button';
import {MatInput} from '@angular/material/input';
import {toSignal} from '@angular/core/rxjs-interop';
import {AppState} from '../../store/store';
import {
  login,
  requestCode,
} from '../../store/auth/auth.actions';
import {countdown} from '../../functions/utils';
import {AlertsService} from '../../services/alerts/alerts.service';
import {CommunicationWay} from '../../store/contact/contact.model';
import {FormWrapperComponent} from '../form-wrapper/form-wrapper.component';

@Component({
  selector: 'app-login-form',
  imports: [TranslatePipe, FormWrapperComponent, MatButton, ReactiveFormsModule, MatInput],
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss',
})
export class LoginFormComponent {

  private readonly store: Store<AppState> = inject(Store<AppState>);

  private readonly alerts: AlertsService = inject(AlertsService);

  private readonly translate: TranslateService = inject(TranslateService);

  public readonly username: InputSignal<string> = input<string>('');

  public readonly communicationWay: InputSignal<string | null> = input<string | null>('');

  public readonly contact: InputSignal<string | null> = input<string | null>('');

  protected readonly step: WritableSignal<number> = signal<number>(1);

  private readonly tryAgain$: Subject<void> = new Subject<void>();

  public readonly cooldown: Signal<number> = toSignal(
    this.tryAgain$.pipe(switchMap(() => countdown(20))),
    {initialValue: 0},
  );

  protected readonly CommunicationWay = CommunicationWay;

  public codeControl = new FormControl('', [
    Validators.required,
  ]);

  handleCodeGet(): void {
    this.store.dispatch(
      requestCode({
        username: this.username(),
      }),
    );
    this.step.set(2);
  }

  handleLogin(): void {
    if (this.codeControl.invalid) {
      this.alerts.showInfo({
        statusText: this.translate.instant('login.invalid_code_error_type'),
        message: this.translate.instant('login.please_provide_your_login_code'),
      });
      return;
    }
    this.store.dispatch(
      login({
        username: this.username(),
        password: this.codeControl.value || '',
      }),
    );
  }

  handleTryAgain(): void {
    this.handleCodeGet();
    this.tryAgain$.next();
  }

}
